<template>
  <account-modal class="remove-tkb-swifts-modal">
    <template slot="heading">
      <template>Remove TARGET2 participants?</template>
    </template>

    <template slot="content">
      <p class="mb-2">Please, confirm that you want to remove TARGET2 participants</p>
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        @click="onConfirmButtonClick"
      >Confirm
      </v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel
      </v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { TARGET2_REMOVE_CONFIRM } from '@/components/target2/events'

  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'
  import AccountModal from '@/components/accounts/AccountModal'

  export default {
    name: 'Target2RemoveModal',
    components: {
      AccountModal
    },
    data () {
      return {
        accountBlockApiRequest: new ApiRequest(AccountApi.block),
        form: { reason: null },
        requiredFields: ['reason']
      }
    },
    computed: {
      ...mapGetters('modal', ['modal'])
    },
    methods: {
      ...mapActions('modal', ['closeModal']),
      onConfirmButtonClick () {
        this.$eventHub.$emit(TARGET2_REMOVE_CONFIRM)
        this.closeModal()
      },
      onCancelButtonClick () {
        this.closeModal()
      }
    }
  }
</script>
